import axios from "@/utils/axios";

enum Api {
  pay = "/wxapi/wechat/pay/createOrder",
  queryPay = "/wxapi/wechat/pay/queryOrder",
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace Recharge {
  export interface payResObj {
    appId: string;
    nonceStr: string;
    packageValue: string;
    paySign: string;
    signType: string;
    timeStamp: string;
    outTradeNo: string;
  }
  export interface PayReqForm {
    total: number | string;
  }
  export interface queryResObj {
    msg: string;
    amount: number;
    isSuccess: boolean;
  }
  export interface queryResParams {
    outTradeNo?: string;
  }
}

// 下单
export const pay = (params: Recharge.PayReqForm) => {
  return axios.post<Recharge.payResObj>(Api.pay, params);
};

// 查询下单结果
export const queryPayRes = (params: Recharge.queryResParams) => {
  return axios.get<Recharge.queryResObj>(Api.queryPay, params);
};
